
import Vue from "vue"
import { mapState } from "vuex"
import eventsDivisionsStub from "./events.divisions.stub"
import DatePicker from "@/components/DatePicker.vue"

export default Vue.extend({
  name: "EventsDivisionsForm",

  components: {
    DatePicker
  },

  props: {
    value: { type: Object, default: () => eventsDivisionsStub }
  },

  computed: {
    ...mapState("events/divisions", {
      eventsDivisionsStateCategories: "categories",
      eventsDivisionsStateConditions: "conditions"
    })
  },

  watch: {
    value: {
      deep: true,
      handler(data): void {
        data.distance = parseInt(data.distance)
        data.standsCount = parseInt(data.standsCount)
        this.$emit("input", data)
      }
    }
  },

  methods: {
    submit(cb): void {
      this.$refs.localForm.validate()
        ? cb()
        : this.$error(this.$t("validationError"))
    },

    resetFields(): void {
      this.$refs.localForm.reset()
    }
  }
})
